module.exports = __webpack_public_path__ + "static/media/douthlondon.52bd733e.png";